import React from 'react';

import TestimonialImage from '../images/testimonial.jpg';
import TestimonialImage2 from '../images/testimonial2.jpg';

function Testimonials() {
  return (
    <section className="relative">

      {/* Illustration behind content */}
      <div className="absolute left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -mb-32" aria-hidden="true">
        <svg width="1760" height="518" viewBox="0 0 1760 518" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-02">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g transform="translate(0 -3)" fill="url(#illustration-02)" fillRule="evenodd">
            <circle cx="1630" cy="128" r="128" />
            <circle cx="178" cy="481" r="40" />
          </g>
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
            <p className="text-xl text-gray-600"><b>Homeowners and home decor professionals alike love our platform.</b></p>
            <br></br>
            <p className='text-s'>Homeowners generate design ideas, professionals tap on this user-generated content as cues to serve them better.</p>
          </div>



          {/* Testimonials */}
          <div className="max-w-3xl mx-auto mt-5" data-aos="zoom-y-out">
            <div className="mb-20 relative flex items-start border-2 border-gray-200 rounded bg-white">

              {/* Testimonial */}
              <div className="text-center px-12 py-8 pt-20 mx-4 md:mx-0">
                <div className="absolute top-0 -mt-8 left-1/2 transform -translate-x-1/2">
                  <img className="relative rounded-full" src={TestimonialImage} width="96" height="96" alt="Testimonial 01" />
                </div>
                <blockquote className="text-xl font-medium mb-4">
                  “As a built environment professional, I really love how AI HD lets people use generative AI to share design ideas in a social experience! This helps professionals to grasp what homeowners want.“
                </blockquote>
                <cite className="block font-bold text-lg not-italic mb-1">Ang Yu Qian</cite>
                <div className="text-gray-600">
                  <span>Built Environment and Design Professional, PhD Candidate at the MIT Sustainable Design Lab, and Cofounder of MIT DesignX + Techstars startup </span> <a className="text-blue-600 hover:underline" href="https://ootb.education">Out of the Box</a>
                </div>
              </div>

            </div>
          </div>

          {/* Testimonials */}
          <div className="max-w-3xl mx-auto mt-5" data-aos="zoom-y-out">
            <div className="relative flex items-start border-2 border-gray-200 rounded bg-white">

              {/* Testimonial */}
              <div className="text-center px-12 py-8 pt-20 mx-4 md:mx-0">
                <div className="absolute top-0 -mt-8 left-1/2 transform -translate-x-1/2">
                  <img className="relative rounded-full" src={TestimonialImage2} width="96" height="96" alt="Testimonial 01" />
                </div>
                <blockquote className="text-xl font-medium mb-4">
                  “This has been an invaluable tool in planning for renovation. Not only do I get to speak my designs to life, I can reimagine an existing space in a style that I want. Mindblowing!“
                </blockquote>
                <cite className="block font-bold text-lg not-italic mb-1">Limonium Sua</cite>
                <div className="text-gray-600">
                  <span>Propsective Homeowner</span>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Testimonials;